<!--INSTRUCTION DETAILS-->
<div class="instruction-details flexbox full-width">
  <!--INSTRUCTION TYPE ICONS-->
  <!--NOTE: The icon will toggle based on instruction type, so only 1 icon css will be applied-->
  <div class="margin-right-small">
    <i class="icon medium red" [ngClass]="instructionType | instructionTypeIcon"> </i>
  </div>
  <div class="margin-right-smallest">
    <h3 class="title">Instruction Type</h3>
    <div class="margin-top-small flexbox full-width">
      <!--TEMPLATE FOR INSTRUCTOR-LED (VIRTUAL) DISPLAY-->
      <div *ngIf="instructionTypeFlag; then thenBlock; else elseBlock"></div>
      <h4 class="margin-right-smallest">
        <ng-template #thenBlock>{{ instructionType }} (Virtual)</ng-template>
        <ng-template #elseBlock>{{ instructionType }}</ng-template>
      </h4>
      <!--END TEMPLATE-->
      <!--INFORMATION TOOLTIP-->
      <app-information-tooltip
        [tooltipData]="getInstructionTypeTooltip(instructionType)"
        [tooltipIcon]="'info-icon'"
        [iconSize]="'x-smallest'"
        [iconColor]="'red'">
      </app-information-tooltip>
      <!--END INFORMATION TOOLTIP-->
    </div>
  </div>
  <!--END INSTRUCTION TYPE ICONS-->
  <!--DURATION IN DAYS OR MINUTES-->
  <ng-container *ngIf="durationFlag">
    <app-duration
      [showDuration]="instructionType | showDurationByInstructionType : true"
      [duration]="courseDuration"
      [iconColor]="'black'"
      [iconSize]="'small'"
      [iconClass]="'duration flexbox'"
      [showIcon]="true">
    </app-duration>
  </ng-container>
  <!--END DURATION IN DAYS OR MINUTES-->
  <!--PRINT BUTTON ICON-->
  <ng-container *ngIf="printFlag">
    <app-printer [ngClass]="'margin-left-auto'"></app-printer>
  </ng-container>
  <!--END PRINT BUTTON ICON-->
</div>
<!--END INSTRUCTION DETAILS-->

<!--PRINTER VERSION INSTRUCTION TYPE-->
<div class="printer-view-instructor-type">
  <h5>Available in the following instruction type(s)</h5>
  <div class="block-content">
    <ul>
      <li>
        {{ instructionType }}
        <!--DURATION IN DAYS OR MINUTES-->
        <app-duration
          [showDuration]="instructionType | showDurationByInstructionType : true"
          [duration]="courseDuration"
          [iconClass]="'flexbox'"
          [showIcon]="false"
          [ngClass]="'inline'">
        </app-duration>
        <!--END DURATION IN DAYS OR MINUTES-->
      </li>
    </ul>
  </div>
</div>
<!--END PRINTER VERSION INSTRUCTION TYPE-->
